export default __webpack_public_path__ + "static/media/graph-right-arrow.1d3a73fc.svg";